import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledWrapper = styled.div`
  left: -20px;
  position: relative;
  right: -20px;
  width: calc(100% + 40px);

  :before,
  :after {
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.01) 9%,
      rgba(255, 255, 255, 0.05) 17%,
      rgba(255, 255, 255, 0.11) 27%,
      rgba(255, 255, 255, 0.18) 36%,
      rgba(255, 255, 255, 0.26) 45%,
      rgba(255, 255, 255, 0.35) 53%,
      rgba(255, 255, 255, 0.45) 62%,
      rgba(255, 255, 255, 0.55) 70%,
      rgba(255, 255, 255, 0.65) 77%,
      rgba(255, 255, 255, 0.74) 83%,
      rgba(255, 255, 255, 0.82) 89%,
      rgba(255, 255, 255, 0.89) 94%,
      rgba(255, 255, 255, 0.95) 97%,
      rgba(255, 255, 255, 0.99) 99%,
      #ffffff
    );
    content: '';
    height: 100%;
    left: 0;
    opacity: 0.72;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 188px;
  }

  :after {
    left: auto;
    position: absolute;
    right: 0;
    transform: rotate(180deg);
  }

  ${({ theme }) => theme.media.tablet} {
    left: 0;
    right: 0;
    width: 100%;

    :before,
    :after {
      display: none;
    }
  }
`

const StyledLanguageList = styled.ul`
  -webkit-overflow-scrolling: touch;
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-top: 24px;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }

  ${({ theme }) => theme.media.desktop} {
    margin-top: 48px;

    @-moz-document url-prefix() {
      overflow: hidden;
    }
  }
`

const StyledLanguage = styled.li`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  padding: 0 20px;

  ${({ theme }) => theme.media.desktop} {
    display: block;
    padding: 0;
  }
`

const LanguageList = ({ langs }) => {
  return (
    <StyledWrapper>
      <StyledLanguageList>
        {langs.map(lang => (
          <StyledLanguage key={lang.id}>
            <img alt={lang.name} loading="lazy" src={lang.icon.file.url} />
          </StyledLanguage>
        ))}
      </StyledLanguageList>
    </StyledWrapper>
  )
}

LanguageList.propTypes = {
  langs: PropTypes.array.isRequired,
}

export default LanguageList
